export class Response {
    status: number;
    message: string;
    timestamp: any;
    data: any;
}

export class APIResponse<T> {
    status?: number;
    message?: string;
    timestamp?: string;
    data: T;
}
